



















import Vue from "vue";
import Component from "vue-class-component";
import UsersTable from "@/components/tables/users-table.vue";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import TabsSettings from "@/components/tabs/settings.vue";

@Component({
    name: "users",
    components: { TabsSettings, PageHeader, UsersTable, Page },
})
export default class Users extends Vue {
    numUsers: number = 0;
}
